import React, { useState } from "react";
import FunImage from "components/FunImage";
import UserService from "services/UserService";

export default ({ profile, setProfile, isOwner }) => {
  const [isUploading, setIsUploading] = useState({
    secondary_image_1: false,
    secondary_image_2: false,
  });

  const heading = {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: "10px",
  };

  const updateFunImage = async (key, image) => {
    setIsUploading({
      ...isUploading,
      [key]: true,
    });
    try {
      await UserService.updateFunPic(key, image);

      setProfile({
        ...profile,
        profile: {
          ...profile.profile,
          [key]: image ? URL.createObjectURL(image) : null,
        },
      });
    } catch (e) {
      console.log(e);
    } finally {
      setIsUploading({
        ...isUploading,
        [key]: false,
      });
    }
  };
  return (
    <>
      <div style={heading}>Fun Pics</div>
      <div className="row FunImageContainer">
        <FunImage
          src={profile?.profile?.secondary_image_1}
          isOwner={isOwner}
          isUploading={isUploading.secondary_image_1}
          onUpdate={(image) => {
            updateFunImage("secondary_image_1", image);
          }}
        />
        <FunImage
          src={profile?.profile?.secondary_image_2}
          isOwner={isOwner}
          isUploading={isUploading.secondary_image_2}
          onUpdate={(image) => {
            updateFunImage("secondary_image_2", image);
          }}
        />
      </div>
    </>
  );
};
